module.exports = __webpack_public_path__ + "static/media/status-pending.20e14779.svg";